import { render, staticRenderFns } from "./License.vue?vue&type=template&id=0df171b3"
import script from "./License.js?vue&type=script&lang=js&external"
export * from "./License.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports